import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { Form } from 'react-bootstrap'
import ExtraGroup from './ExtraGroup'
import TreeView from 'react-treeview'


@inject("store")
@observer
export default class ExtraSelector extends Component {
  renderAllExtrasCheckbox() {
    const { store, extraCategory } = this.props
    return (
      <Form.Check
        onChange={() => store.toggleExtraCategorySelection(extraCategory.id)}
        checked={extraCategory.selected || false}
        style={styles.checkbox}
        label={`All ${extraCategory.pluralized_name}`}
        id={`allExtras_${extraCategory.id}`}
      />
    )
  }

  render() {
    const { allowSelectAll, showCheckboxes, onClickExtra, store, extraCategory } = this.props

    if(allowSelectAll) {
      return (
        <TreeView
          onClick={() => store.toggleExtraCategoryCollapsed(extraCategory.id)}
          collapsed={extraCategory.collapsed}
          nodeLabel={this.renderAllExtrasCheckbox()}
        >
          <div style={styles.offset}>
            {extraCategory.extraGroups.map((extraGroup, i) =>
              <ExtraGroup
                key={extraGroup.id}
                extraGroup={extraGroup}
                onClickExtra={onClickExtra}
                showCheckboxes={showCheckboxes}
              />
            )}
          </div>
        </TreeView>
      )
    }
    else {
      return (
        <div style={styles.offset}>
          {extraCategory.extraGroups.map((extraGroup, i) =>
            <ExtraGroup
              key={extraGroup.id}
              extraGroup={extraGroup}
              onClickExtra={onClickExtra}
              showCheckboxes={showCheckboxes}
            />
          )}
        </div>
      )
    }
  }
}

const styles = {
  checkbox: {
    display: "inline-block",
    marginTop: 0,
    marginBottom: 5
  },
  offset: {
    marginLeft: 10
  }
}